import React, { FC, useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  NotificationButtons,
  NotificationMessages,
  useTrackNotificationInteraction,
} from '../../utils/hooks/bi/useTrackNotificationInteraction';
import { EmptyStateGeneric } from '../common/EmptyStateGeneric';
import { Button } from '../common/wixCommon';
import { ReactComponent as ServerErrorIcon } from './icons/serverErrorIcon.svg';

export const EmptyStateServerError: FC<{ onActionButtonClick: () => void }> = ({
  onActionButtonClick,
}) => {
  const {
    trackErrorShown,
    trackErrorClick,
  } = useTrackNotificationInteraction();

  useEffect(() => {
    trackErrorShown({ errorMessage: NotificationMessages.ServerErrorMyVideos });
  }, [trackErrorShown]);

  const handleButtonClick = useCallback(() => {
    onActionButtonClick();
    trackErrorClick({
      buttonName: NotificationButtons.TryAgain,
      errorMessage: NotificationMessages.ServerErrorMyVideos,
    });
  }, [onActionButtonClick, trackErrorClick]);

  return (
    <EmptyStateGeneric
      dataHook="empty-state-server-error"
      title={
        <FormattedMessage id="video-maker-home.empty-state.item-load-fail.title" />
      }
      subtitle={
        <FormattedMessage id="video-maker-home.empty-state.item-load-fail.description" />
      }
      image={<ServerErrorIcon />}
    >
      <Button
        dataHook="empty-state-server-error-action-button"
        onClick={handleButtonClick}
      >
        <FormattedMessage id="video-maker-home.empty-state.item-load-fail.action.link" />
      </Button>
    </EmptyStateGeneric>
  );
};
